import React from 'react';
import {
  TextField,
  FunctionField,
  useRecordContext,
} from 'react-admin';
import { Box, Typography, Link, Paper } from '@mui/material';
import { CopyIcon } from '@troverecommerce/saas-components-ts';
import { DashboardCurrency } from '@src/utils/valueFormatters';
import type { RepairDetail } from '@src/types';

const ShowStatusSection = () => {
  const record = useRecordContext<RepairDetail>();

  if (!record) return null;

  return (
    <Paper>
      <Box sx={{ padding: 2 }}>
        <Box sx={{ marginBottom: 3 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, marginBottom: 1 }}>
            <Typography variant="h6">
              Repair Order:
              {' '}
              {record.uuidPrefix}
            </Typography>
            <CopyIcon name="Repair ID" value={record.uuidPrefix} />
          </Box>
          <Box sx={{ display: 'grid', gridTemplateColumns: '200px 1fr', gap: 1, marginTop: 2 }}>

            <Typography variant="body2" fontWeight="bold">Current Status:</Typography>
            <TextField source="status" />

            <Typography variant="body2" fontWeight="bold">Promo Code Used:</Typography>
            <FunctionField
              render={(record: RepairDetail) => record.promoCode ?? 'N/A'}
            />

            <Typography variant="body2" fontWeight="bold">Repair Fee:</Typography>
            <FunctionField
              render={(record: RepairDetail) => DashboardCurrency.displayValue(record.price, record.currencyCode)}
            />

            <Typography variant="body2" fontWeight="bold">Repair Shipping Fee:</Typography>
            <FunctionField
              render={(record: RepairDetail) => DashboardCurrency.displayValue(record.shippingPrice, record.currencyCode)}
            />

            <Typography variant="body2" fontWeight="bold">Inbound Tracking Number:</Typography>
            {record.inboundShippingInfo?.trackingUrl ? (
              <Link href={record.inboundShippingInfo?.trackingUrl} target="_blank" rel="noopener">
                {record.inboundShippingInfo?.trackingNumber ?? 'N/A'}
              </Link>
            ) : (
              <Typography variant="body2">{record.inboundShippingInfo?.trackingNumber ?? 'N/A'}</Typography>
            )}

            <Typography variant="body2" fontWeight="bold">Outbound Tracking Number:</Typography>
            {record.outboundShippingInfo?.trackingUrl ? (
              <Link href={record.outboundShippingInfo?.trackingUrl} target="_blank" rel="noopener">
                {record.outboundShippingInfo?.trackingNumber ?? 'N/A'}
              </Link>
            ) : (
              <Typography variant="body2">{record.outboundShippingInfo?.trackingNumber ?? 'N/A'}</Typography>
            )}
          </Box>
        </Box>
      </Box>
    </Paper>
  );
};

export default ShowStatusSection;
